<template>
  <div class="page-top-space"></div>
  <BusinessByClientTable/>
</template>

<script>
    import BusinessByClientTable from "@/components/tables/BusinessByClientTable.vue";

    export default {
      name: 'BusinessByClientListView',
      components: {
        BusinessByClientTable
      }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  h1
    color: THEME_COLOR_PRIMARY
    span
      color: THEME_COLOR_PRIMARY_FADDED
</style>

<style lang="stylus">
  main
    align-content start
</style>